export enum AgendaFilterDate {
    All = 0,
    ThisWeek = 1,
    NextWeek = 2,
    After = 3,
}
